__turbopack_context__.v({
  "productArticlesHeader": "product-articles-module-scss-module__T1XO9G__productArticlesHeader",
  "productArticlesViewAll": "product-articles-module-scss-module__T1XO9G__productArticlesViewAll",
  "productArticlesViewAllMobile": "product-articles-module-scss-module__T1XO9G__productArticlesViewAllMobile",
});
